import { render, staticRenderFns } from "./FacialDeviceEmployeeAvailableTable.vue?vue&type=template&id=05e3b048&scoped=true&"
import script from "./FacialDeviceEmployeeAvailableTable.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceEmployeeAvailableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3b048",
  null
  
)

export default component.exports